import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../userContext";
import { useContext } from "react";

export default function Portal() {
  const { t, i18n } = useTranslation("common");
  const user = useContext(UserContext);
  const teamsUrl =
    user?.teamsRole.search("lba") !== -1 &&
    user?.teamsRole.search("staff") == -1
      ? "/my-courses"
      : "/teams";
  return (
    <Container style={{ maxWidth: "800px" }}>
      <h3>{t("portal.title")}</h3>
      <Row>
        <Col className="d-flex">
          <Card className="flex-grow-1">
            <Card.Body className="d-flex flex-column">
              <Card.Title>{t("portal.courseOrderTool.title")}</Card.Title>
              <Card.Text className="flex-grow-1">
                <p dangerouslySetInnerHTML={{ __html: t("portal.courseOrderTool.description") }} />
                <div>
                  <p>
                    <strong>{t("portal.courseOrderTool.importantInfo")}</strong>
                  </p>
                  <p>
                    <strong>
                      <i>{t("portal.courseOrderTool.forLecturers")}</i>
                    </strong>{" "}
                    {t("portal.courseOrderTool.forLecturersText")}
                  </p>
                </div>
              </Card.Text>
              <Button
                variant="secondary"
                as="a"
                href="/my-courses"
                style={{ backgroundColor: "#194866" }}
              >
                {t("portal.courseOrderTool.button")}
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card>
            <Card.Body className="d-flex flex-column">
              <Card.Title>{t("portal.teamsOrderForm.title")}</Card.Title>
              <Card.Text className="flex-grow-1">
                <p>{t("portal.teamsOrderForm.description")}</p>
                <div>
                  <p>
                    <strong>{t("portal.teamsOrderForm.importantInfo")}</strong>
                  </p>
                  <p>
                    <strong>
                      <i>{t("portal.teamsOrderForm.general")}</i>
                    </strong>{" "}
                    <span dangerouslySetInnerHTML={{ __html: t("portal.teamsOrderForm.generalText") }} />
                  </p>
                  <p>
                    <strong>
                      <i>{t("portal.teamsOrderForm.forLecturers")}</i>
                    </strong>{" "}
                    <span dangerouslySetInnerHTML={{ __html: t("portal.teamsOrderForm.forLecturersText") }} />
                  </p>
                  <p>
                    <strong>
                      <i>{t("portal.teamsOrderForm.forStudents")}</i>
                    </strong>{" "}
                    {t("portal.teamsOrderForm.forStudentsText")}
                  </p>
                </div>
              </Card.Text>
              <Button
                variant="primary"
                as="a"
                href={teamsUrl}
                style={{ backgroundColor: "#0d6efd" }}
              >
                {t("portal.teamsOrderForm.button")}
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
